

import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import burceMars from "assets/images/bruce-mars.jpg";
import backgroundImage from "assets/images/bg-profile.jpeg";

function Header({ user, children }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const getRolNombre = (rol) => {
    switch (Number(rol)) {
      case 1:
        return "Rector";
      case 6:
        return "Sub Dirección";
      case 7:
        return "Director Académico";
      case 2:
        return "Caja";
      case 3:
        return "Docente";
      case 4:
        return "Estudiante";
      case 5:
        return "Secretaria";
      default:
        return "Sin rol";
    }
  };

  return (
    <MDBox position="relative" mb={5}>
      
      {/* BACKGROUND */}
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="5rem"
        borderRadius="xl"
      />

      {/* CARD */}
      <Card
        sx={{
          position: "relative",
          mt: -10,
          mx: 3,
          p: 3,
          borderRadius: "xl",
          backdropFilter: "blur(10px)",
        }}
      >
        <Grid container spacing={3} alignItems="center">
          {/* INFO */}
          <Grid item xs>
            <MDBox display="flex" flexDirection="column">

              {/* NOMBRE COMPLETO */}
              <MDTypography variant="h5" fontWeight="bold">
                {user.name} {user.apellido_paterno || ""} {user.apellido_materno || ""}
              </MDTypography>

              {/* EMAIL */}
              <MDTypography variant="body2" color="text">
                {user.email}
              </MDTypography>

              {/* ROL */}
              <MDTypography variant="body2" color="info" fontWeight="medium">
                {getRolNombre(user.rol)}
              </MDTypography>

              {/* EXTRA INFO */}
              <MDBox display="flex" gap={3} mt={1} flexWrap="wrap">
                
                {user.ci && (
                  <MDTypography variant="caption" color="text">
                    CI: {user.ci} {user.expedido && `(${user.expedido})`}
                  </MDTypography>
                )}

                {user.celular && (
                  <MDTypography variant="caption" color="text">
                    📱 {user.celular}
                  </MDTypography>
                )}

                {user.username && (
                  <MDTypography variant="caption" color="text">
                    @{user.username}
                  </MDTypography>
                )}

              </MDBox>

            </MDBox>
          </Grid>

        </Grid>

        {/* CONTENIDO */}
        <MDBox mt={3}>
          {children}
        </MDBox>
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
